const quote = {
    namespaced : true,

    state: {
        groupedBills : [],
        selected : [],
        showBillCompareModal : false,
        showBillInfoModal : false,
        activeBillCompareGroup : null,
        activeBillInfo : null,
        isFreePerks: false,
    },

    getters: {

        /*
        Retrieve the group with a specific ID
         */
        getGroupByID : (state) => (id) => {

            for(let i=0; i<state.groupedBills.length; i++) {
                if (state.groupedBills[i].id === id) {
                    return state.groupedBills[i];
                }
            }

            return null;
        },

        /*
        Retrieve all groups and their bills
         */
        getGroupedBills : (state) => {
            return state.groupedBills;
        },

        /*
        Retrieve the group with a specific ID
         */
        getBillByID : (state) => (id) => {

            for(let i=0; i<state.groupedBills.length; i++) {
                for(let j=0; j<state.groupedBills[i].bills.length; j++) {
                    if (state.groupedBills[i].bills[j].id === id) {
                        return state.groupedBills[i].bills[j];
                    }
                }
            }

            return null;
        },

        /*
        Retrieve bills that have been selected
         */
        getSelectedBills : (state) => {
            let selectedBills = [];

            for (let i=0; i< state.groupedBills.length; i++) {
                for(let j=0; j< state.groupedBills[i].bills.length; j++) {
                    for(let k=0; k< state.selected.length; k++) {
                        if(state.groupedBills[i].bills[j].id === state.selected[k]) {
                            selectedBills.push(state.groupedBills[i].bills[j]);
                        }
                    }
                }
            }
            return selectedBills;
        },

        /*
        Check if a bill has been selected
         */
        getBillSelected : (state, getters) => (id) => {
            let allSelected = getters.getSelectedBills;

            for(let i=0; i<allSelected.length; i++) {
                if(allSelected[i].id === id) {
                    return true;
                }
            }

            return false;
        },

        /*
        Get the bill
         */
        getGroupSelected : (state, getters) => (id) => {

            let allSelected = getters.getSelectedBills;

            for(let i=0; i<allSelected.length; i++) {
                if(allSelected[i].group.id === id) {
                    return allSelected[i];
                }
            }

            return null;
        },

        /*
        Retrieve the cheapest priced bill within a group (e.g Internet)
         */
        getGroupCheapestPrice : (state, getters) => (id) => {

            let group = getters.getGroupByID(id);
            let cheapest = parseFloat(group.bills[0].prices[0].price_per_housemate);

            for (let i=1; i < group.bills.length; i++) {
                if(parseFloat(group.bills[i].prices[0].price_per_housemate) < cheapest) {
                    cheapest = parseFloat(group.bills[i].prices[0].price_per_housemate);
                }
            }

            return cheapest.toFixed(2);
        },

        /*
        Retrieve the total price of selected bills for each housemate
         */
        getPriceHousemate : (state, getters) => {

            let pricePerHousemate = 0;

            let selected = getters.getSelectedBills;

            if (selected) {
                for (let i = 0; i < selected.length; i++) {
                    pricePerHousemate += parseFloat(selected[i].prices[0].price_per_housemate);
                }
            }

            return pricePerHousemate.toFixed(2);
        },

        /*
        Retrieve whether the bill compare modal is open
         */
        getShowBillCompareModal : (state) => {
            return state.showBillCompareModal;
        },

        /*
        Retrieve the group currently displayed in the bill compare modal
         */
        getActiveBillCompareGroup : (state, getters) => {
            return getters.getGroupByID(state.activeBillCompareGroup);
        },

        /*
        Retrieve whether the bill info modal is open
         */
        getShowBillInfoModal : (state) => {
            return state.showBillInfoModal;
        },

        /*
        Retrieve the bill currently displayed in the bill info modal
         */
        getActiveBillInfo : (state, getters) => {
            return getters.getBillByID(state.activeBillInfo);
        },

         /*
         check if free perks exists
         */
        getFreePerks : (state) => {
            return state.isFreePerks;
        },

    },

    mutations: {
        /*
        Set the grouped bills
         */
        setBills : (state, payload) => {
            state.groupedBills = payload
        },

        /*
        Add a bill to the list of selected bills
         */
        selectBill : (state, payload) => {
            state.selected.push(payload);
        },

        /*
        Remove a bill from list of selected bills
         */
        deselectBill : (state, payload) => {

            let index = state.selected.indexOf(payload);

            if( index !== -1) {
                state.selected.splice(index, 1);
            }

        },

        /*
        Select all bills with auto selected property
         */
        selectAutoSelected : (state) => {
            for (let i=0; i< state.groupedBills.length; i++) {
                if(state.groupedBills[i].is_auto_selected && state.groupedBills[i].bills.length > 0) {

                    // Override unlimited energy bill as default
                    if (state.groupedBills[i].name === "Renewable Energy" &&
                        _.find(state.groupedBills[i].bills, { id: 684 })
                    ) {
                        state.selected.push(684);
                        continue;
                    }

                    state.selected.push(state.groupedBills[i].bills[0].id);
                }
            }
        },

        /*
        Select all bills
         */
        selectAllBills : (state) => {
            for (let i=0; i< state.groupedBills.length; i++) {
                if (_.has(state.groupedBills[i], 'bills') && state.groupedBills[i].bills.length > 0) {
                    state.selected.push(state.groupedBills[i].bills[0].id);
                }
            }
        },

        /*
        Hide the bill compare modal and reset content
         */
        hideBillCompareModal : (state) => {
            state.showBillCompareModal = false;
            state.activeBillCompareGroup = null;
        },

        /*
        Show the bill compare modal and fill content
         */
        showBillCompareModal : (state, payload) => {
            state.activeBillCompareGroup = payload;
            state.showBillCompareModal = true;
        },

        /*
        Hide the bill info modal and reset content
         */
        hideBillInfoModal : (state) => {
            state.showBillInfoModal = false;
            state.activeBillInfo = null;
        },

        /*
        Show the bill info modal and fill content
         */
        showBillInfoModal : (state, payload) => {
            state.activeBillInfo = payload;
            state.showBillInfoModal = true;
        },
        /*
        Select all perks bills
        */
        selectPerkBills : (state) => {
        let perks = state.groupedBills.filter((group) => group?.is_perk);

        if(perks.length > 0){
            state.isFreePerks = true;
            const bills = perks?.[0]?.bills;
            for (let i = 0; i < bills.length; i++) {
                let index = state.selected.indexOf(bills[i].id);
                 if( index === -1) {
                    state.selected.push(bills[i].id);
                }
            }
        }
        }
    },

    actions: {
        /*
        Toggle whether a bill is selected or deselected
         */
        toggleBillSelected : (context, id) => {
            if(context.getters.getBillSelected(id)) {
                context.commit('deselectBill', id);
            } else {
                context.commit('selectBill', id);
            }
        },

        /*
        Deselects all bills within a group
         */
        deselectGroup : (context, id) => {

            let allSelected = context.getters.getSelectedBills;

            for(let i=0; i<allSelected.length; i++) {
                if(allSelected[i].group.id === id) {
                    context.commit('deselectBill', allSelected[i].id);
                }
            }
        }
    }

};

export default quote;
